import React, { Component } from "react";
import { Button, Row, Col, Accordion, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import _ from "lodash";
import {
  Calendar,
  Mic,
  MicOff,
  ChevronDown,
  ChevronRight,
  Image,
  XCircle,
  PlusCircle,
} from "react-feather";
import { Redirect, withRouter } from "react-router-dom";
import { InviteUser } from "app/shared/components/Popups";

import Url from "app/shared/constants/Url";
import axios from "axios";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import DatePicker from "react-datepicker";
import TimePicker from "react-times";
import AudioPlayer from "react-h5-audio-player";
import { ReactMic } from "react-mic";
import moment from "moment";
import { Link } from "react-router-dom";
import AlertMessage from "app/shared/components/Popups/AlertMessage";
import { NM_TYPE_ACT, TYPE_ACT } from "app/shared/constants/GlobalArray";
import LowSpace from "app/shared/components/Popups/LowSpace";
import CheckFormSettingField from "app/shared/utility/CheckFormSettingField";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import LoadingImage from "app/shared/components/Loader/LoadingImage";
import { ErrorToast } from "app/shared/components/Popups/ToastMessage";
import { convertDateFromTimezone } from "app/shared/utility/tzUtilFunction";
import CommonDropdown from "../../../shared/components/ReportModal/CommonDropdown";
//assets
import {
  RoundDelete,
  RoundEdit,
  RoundSave,
  TeamAdd,
} from "assets/Iconsv2/Iconsv2";

import { Scrollbars } from "react-custom-scrollbars";
import CountGraph from "app/views/Graphs/Graphs/CountGraph";
//seeting
import { config } from "config.js";
import { getInitials } from "app/views/Nm/container/utils/moduleHelp";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
const qs = require("qs");
const DEPT_URL = Url.departmentList;
const CONT_URL = Url.contractorList;
const ZONE_URL = Url.zoneList;
const ACT_URL = Url.activitylist;
//const HZD_URL = Url.hazardList;
const BARRIER_URL = Url.barrierList;
const Div_URL = Url.divisionList;

const userId = localStorage.getItem("userId");
const token = localStorage.getItem("token");

const ErrorMessage = <div className="invalid-feedback">Enter valid name</div>;
const ErrorBlock = ({ message }) => (
  <div className="invalid-feedback">{message || ""}</div>
);
export const SEVERITY = [
  {
    id: 4,
    name: "High Critical",
  },
  {
    id: 3,
    name: "High",
  },
  {
    id: 2,
    name: "Medium",
  },
  {
    id: 1,
    name: "Low",
  },
];

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    width: "100%",
    minHeight: "32px",
    maxHeight: "32px",
    border: "1px solid #E6E6E6",
    borderRadius: "6px",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #FF5A36",
    },
    backgroundColor: state.isDisabled ? "#F9F9F9" : "white",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.7 : 1,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 12px",
    height: "32px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "#444444",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#999",
    fontSize: "16px",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#FFE5E0",
    borderRadius: "4px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#444444",
    fontSize: "13px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#FF5A36",
    "&:hover": {
      backgroundColor: "#FF5A36",
      color: "white",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "#444444",
    fontSize: "16px",
  }),
  menu: (base) => ({
    ...base,
    width: "100%",
    zIndex: 9999,
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#FF5A36"
      : state.isFocused
        ? "#FFE5E0"
        : "white",
    color: state.isSelected ? "white" : "#444444",
    cursor: "pointer",
    padding: "10px 12px",
    fontSize: "14px",
    "&:active": {
      backgroundColor: "#FF5A36",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#999",
    padding: "0 8px",
    "&:hover": {
      color: "#FF5A36",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "#999",
    padding: "0 8px",
    "&:hover": {
      color: "#FF5A36",
    },
  }),
};
class NmEditReportingDetail extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      show: false,
      showUser: false,
      reportDetail: [],
      searchFiledUsers: [],
      nmId: this.props.match.params.id,
      divisionList: [],
      dataLoading: true,
      accordionOpen: true,
      lightboxactive: false,
      subcommentlist: [],
      comment: 0,
      commentAdd: "",
      commentlist: [],
      allComments: false,
      redirectToReferrer: false,
      projectList: [],
      departmentList: [],
      contractorList: [],
      zoneList: [],
      locationList: [],
      typeActList: TYPE_ACT,
      activityList: [],
      subActivityList: [],
      severityList: SEVERITY,
      barrierList: [],
      hazardList: [],
      subHazardList: [],
      selectedServiceId: null,
      selectedProjectId: null,
      selectedDepartmentId: null,
      selectedDivisionId: null,
      selectedContractorId: null,
      selectedZoneId: null,
      selectedLocationId: null,
      selectedTypeAct: null,
      selectedActivity: null,
      selectedSubActivity: null,
      subActivityError: false,
      selectedSeverity: 0,
      selectedBarrier: null,
      selectedHazardId: null,
      selectedSubHazardId: null,
      selectedTargetDate: new Date(),
      selectedIncidentDate: new Date(),
      selectedOldDate: new Date(),
      maxDatepickerDate: new Date(),
      observationText: "",
      evidenceFileList: [],
      evidenceUrlList: [],
      serviceId: this.props.match.params.serviceId,
      projectId: this.props.match.params.projectId,
      reportDetailevidence: [],
      showRecorderModal: false,
      recordAudio: false,
      controlMeasureAudio: "",
      controlMeasureURL: "",
      observationAudio: "",
      observationURL: "",
      recordingFor: "observation",
      controlMeasureFileStatus: 0,
      observationFileStatus: 0,
      evidenceFileStatus: 0,
      isCheckLowSpace: false,
      lowStorageMessage: "",
      lowStorageStatus: 200,
      showLowStoragePopup: false,
      formSetting: [],
      selectedIncidentTime: "10:00",
      selectedTimeMeridiem: "",
      incidentPersonName: "",
      userLike: [],
      likeNumber: "",
      addedFiles: [],
      files: [],
      deletedEvidencesIds: [],
      showContractorDropdown: true,
      showZoneLocationDropdown: true,
      incidentPersons: [],
      idList: [],
      incidentPersonNameError: false,
      injuredPersonName: "",
      injuredPersonID: "",
      userData: JSON.parse(localStorage.getItem("userData")),
      organisationSetting: false,
      isHazardInvalid: false,
      isSubHazardInvalid: false,
    };
    this.openInviteUser = this.openInviteUser.bind(this);
  }

  openInviteUser() {
    const showUser = !this.state.showUser;
    this.setState({
      showUser,
    });
  }

  componentDidMount() {
    this._fetchOrganisationSetting();
  }

  _getDb = () => {
    const hostname = window.location.hostname.toLowerCase();

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "stageclide";
    }

    if (hostname.endsWith(".clideanalyser.in")) {
      const db = hostname.replace(".clideanalyser.in", "").trim();

      if (db === "qaclide") {
        return "stageclide";
      }

      return db;
    }

    return hostname.split(".")[0] || "stageclide";
  };

  _fetchOrganisationSetting = async () => {
    try {
      const response = await axios.get(Url.organisationSettingByDb, {
        params: { db: this._getDb() },
      });
      const enabled = !!response?.data?.data?.organisationSetting;

      this.setState({ organisationSetting: enabled });
      this.reportDetail();
      this._fetchProjectListFlag(this.state.serviceId);
    } catch (error) {
      // On failure, treat the setting as ON (mirrors NmReport.js)
      this.setState({ organisationSetting: true });
      this.reportDetail();
      this._fetchProjectListFlag(this.state.serviceId);
    }
  };

  _isRiskRegisterMode = () => {
    if (this.state.organisationSetting) {
      return true;
    } else {
      return false;
    }
  };

  _fetchProjectListFlag = async (serviceId) => {
    const { reportType } = this.state;
    let moduleId = 2;

    let requestData = {
      service_id: serviceId,
      module_name: "near_miss",
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpring(
        Url.projectListForm,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let {
                showContractorDropdown,
                showZoneLocationDropdown,
                projectList,
              } = prevState;

              projectList = response.data.data;

              // check contractor flag
              const isContractor = projectList.map(
                (item) => item.contractor_flag,
              );
              showContractorDropdown = isContractor == 0 ? false : true;
              console.log("isContractor == " + isContractor);

              const isZoneLocation = projectList.map(
                (item) => item.zone_location_flag,
              );
              showZoneLocationDropdown = isZoneLocation == 0 ? false : true;
              console.log("isZoneLocation == " + isZoneLocation);

              return {
                showContractorDropdown,
                showZoneLocationDropdown,
                projectList,
              };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _setDataLoading = async (status) => {
    await this.setState((prevState) => {
      let { dataLoading } = prevState;
      dataLoading = status;
      return { dataLoading };
    });
  };

  async reportDetail() {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    var datailUrl = Url.nmModule.springnmDetail;

    await axios
      .post(
        datailUrl,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          nearMissId: this.state.nmId,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          params: {
            auth_key: token,
            user_id: userId,
          },
        },
      )
      .then(async (response) => {
        if (response.data.status == 200) {
          const oldDate = response.data.data.target_date
            ? this._momentDate(response.data.data.target_date)
            : new Date();
          await this.setState({
            reportDetail: response.data.data,
            formSetting: response.data.form_setting,
            selectedActivity: response.data.data.activity_id,
            selectedSubActivity: response.data.data.subActivity,
            selectedTypeAct: response.data.data.type_of_act,
            selectedBarrier: response.data.data.barrier_id,
            selectedHazardId: response.data.data.hazard_id,
            selectedSubHazardId: response.data.data.subHazard,
            selectedEvidence: response.data.data.evidence,
            observationURL: response.data.data.observation_record,
            observationText: response.data.data.observation,
            incidentPersonName: response.data.data.incident_person_details,
            controlMeasure: response.data.data.control_measure,
            controlMeasureURL: response.data.data.control_measure_recording,
            selectedDepartmentId: response.data.data.department_id,
            selectedDivisionId: response.data.data.division_id,
            selectedContractorId: response.data.data.contractor_id,
            selectedZoneId: response.data.data.zone_id,
            selectedLocationId: response.data.data.location_id,
            invited_user: response.data.data.invited_user,
            selectedSeverity: response.data.data.severity_number,
            selectedTargetDate: oldDate,
            selectedIncidentDate: this._momentDate(
              response.data.data.incident_date,
            ),
            selectedOldDate: oldDate,
            evidenceImage:
              response.data.data.nm_reported_detail_evidence_images,
            selectedIncidentTime: response.data.data.incident_time,
            incidentPersons: response.data.data.incident_person_details.map(
              (el) => {
                return {
                  ...el,
                  status: "NoChange",
                };
              },
            ),
          });

          await this._fetchOptionList();
          if (!this.state.organisationSetting) {
            await this._fetchSubHazardList(response.data.data.subHazard);
          }
          await this.setState({
            dataLoading: false,
            // selectedTargetDate: response.data.data.target_date
          });
        }
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  }

  _redirectToDetail = () => {
    this.props.history.goBack();
    // this.setState({ redirectToReferrer: true });
  };

  _momentDate = (stringDate) => moment(stringDate, "DD-MM-YYYY").toDate();

  isEmpty = (val) =>
    !val || val === "" || val === null || val === undefined || val === "0";

  validateForm = () => {
    let isValid = true;

    // Activity
    if (this.isEmpty(this.state.selectedActivity)) {
      this.setState({ activityError: true });
      isValid = false;
    }

    if (
      CheckFormSettingField(this.state.formSetting?.setting, "sub activity")
    ) {
      if (this.isEmpty(this.state.selectedSubActivity)) {
        this.setState({ subActivityError: true });
        isValid = false;
      } else {
        this.setState({ subActivityError: false });
      }
    }

    if (
      this.isEmpty(this.state.selectedHazardId) ||
      this.state.selectedHazardId === "0" ||
      this.state.selectedHazardId === 0
    ) {
      this.setState({ isHazardInvalid: true });
      isValid = false;
    } else {
      this.setState({ isHazardInvalid: false });
    }

    if (CheckFormSettingField(this.state.formSetting?.setting, "sub hazard")) {
      if (
        this.isEmpty(this.state.selectedSubHazardId) ||
        this.state.selectedSubHazardId === "0"
      ) {
        this.setState({ isSubHazardInvalid: true });
        isValid = false;
      } else {
        this.setState({ isSubHazardInvalid: false });
      }
    }

    if (this.isEmpty(this.state.selectedTypeAct)) {
      isValid = false;
    }

    const isDepartmentSelected = !this.isEmpty(this.state.selectedDepartmentId);
    const isContractorSelected = !this.isEmpty(this.state.selectedContractorId);
    const isZoneSelected = !this.isEmpty(this.state.selectedZoneId);
    const isLocationSelected = !this.isEmpty(this.state.selectedLocationId);

    // zone + location only if enabled for project
    const isZoneLocationEnabled =
      CheckFormSettingField(this.state.formSetting?.setting, "zone") &&
      CheckFormSettingField(this.state.formSetting?.setting, "location") &&
      this.state.projectList.find(
        (proj) =>
          proj.project === this.state.reportDetail.project_name &&
          proj.zone_location_flag === 1,
      );

    const isZoneLocationSelected =
      isZoneLocationEnabled && isZoneSelected && isLocationSelected;

    if (
      !isDepartmentSelected &&
      !isContractorSelected &&
      !isZoneLocationSelected
    ) {
      this.setState({
        departmentError: true,
        contractorError: true,
        zoneError: isZoneLocationEnabled,
        locationError: isZoneLocationEnabled,
      });

      isValid = false;
    }

    return isValid;
  };

  EditreportDetail = async () => {
    if (!this.validateForm()) {
      //this.errorRef.current.scrollIntoView({ behavior: "smooth" });

      ErrorToast(
        "Please fill all required fields. Select either Department or Contractor or both Zone and Location.",
      );
      return false;
    }
    this.setState({ dataLoading: true });

    let { ...eData } = this.state;

    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    let targetDate = moment(this.state.selectedTargetDate).format("YYYY-MM-DD");
    let incidentDate = moment(this.state.selectedIncidentDate).format(
      "YYYY-MM-DD",
    );

    //  let targetDate = convertDateToUTC(this.state.selectedTargetDate, "YYYY-MM-DD");
    //  let incidentDate = convertDateToUTC(this.state.selectedIncidentDate, "YYYY-MM-DD");

    var controlMeasureURL =
      eData.controlMeasureFileStatus == 2
        ? eData.controlMeasureAudio
        : eData.controlMeasureURL;
    var observationURL =
      eData.observationFileStatus == 2
        ? eData.observationAudio
        : eData.observationURL;

    let nmData = new FormData();

    nmData.append("auth_key", token);
    nmData.append("user_id", userId);
    nmData.append("nearMissId", eData.nmId);
    nmData.append("serviceId", eData.serviceId);
    nmData.append("projectId", eData.projectId);

    if (this.state.organisationSetting) {
      nmData.append("companyId", eData.reportDetail?.companyId ?? "");
      nmData.append(
        "projectCategory",
        eData.reportDetail?.projectCategoryId || "",
      );
      nmData.append("region", eData.reportDetail?.region || "");
      nmData.append("state", eData.reportDetail?.state || "");
      nmData.append("city", eData.reportDetail?.city || "");
    }

    let hazardIdToSend = eData.selectedHazardId ?? 0;
    let subHazardIdToSend = eData.selectedSubHazardId ?? 0;
    if (this._isRiskRegisterMode()) {
      const hazardNode = this._currentRrHazards().find(
        (h) => h.hazardId == eData.selectedHazardId,
      );
      if (hazardNode) {
        hazardIdToSend = hazardNode.oldHazardId ?? hazardIdToSend;
        const subHazardNode = (hazardNode.subHazards || []).find(
          (sh) => sh.subHazardId == eData.selectedSubHazardId,
        );
        if (subHazardNode) {
          subHazardIdToSend = subHazardNode.oldSubHazardId ?? subHazardIdToSend;
        }
      }
    }
    nmData.append("hazardId", hazardIdToSend);

    const subHazardId = !eData.selectedHazardId ? 0 : subHazardIdToSend;

    nmData.append("subHazardId", subHazardId);

    nmData.append("activityId", eData.selectedActivity);
    nmData.append("subActivity", eData.selectedSubActivity || 0);
    nmData.append("typeOfAct", eData.selectedTypeAct);
    nmData.append("severity", eData.selectedSeverity);
    nmData.append("departmentId", eData.selectedDepartmentId || 0);
    nmData.append("divisionId", eData.selectedDivisionId || 0);
    nmData.append("contractorId", eData.selectedContractorId || 0);
    nmData.append("zoneId", eData.selectedZoneId || 0);
    nmData.append("locationId", eData.selectedLocationId || 0);
    nmData.append("observation", eData.observationText);
    // nmData.append("person_name", eData.incidentPersonName);
    // nmData.append("target_date", targetDate);
    nmData.append("incidentTime", eData.selectedIncidentTime);
    nmData.append("incidentDate", incidentDate);
    nmData.append("employeeMasterId", 1);
    nmData.append("lat", 0);
    nmData.append("lang", 0);
    nmData.append("observationRecord", 0);

    if (this.state.deletedEvidencesIds?.length) {
      this.state.deletedEvidencesIds.forEach((data) => {
        nmData.append("evidenceDeleteId", data);
      });
    }
    console.log(this.state.files);

    this.state.files.forEach((item) => {
      nmData.append("file", item.file);
      console.log(item.file);
      // nmData.append("file_status", item.file_status);
      // nmData.append("file_id", item.file_id);
    });

    nmData.append("observationRecord", observationURL);

    let combinedPersons = [
      ...this.state.incidentPersons,
      ...this.state.searchFiledUsers,
    ];

    if (combinedPersons.length > 0) {
      let incidentPersonString = JSON.stringify(
        combinedPersons.map((person) => ({
          incidentPersonId: person.incident_person_id,
          incidentPersonName: person.incident_person_name,
          searchIncidentPersonId: person.searched_incident_person_id || null,
        })),
      );
      nmData.append("incidentPersonString", incidentPersonString);
    }

    //console.log("nmData ", Object.fromEntries(nmData.entries()));
    //return;
    var datailUrl = Url.nmModule.springnmEdit;
    let headerType = "multipart/form-data";
    await axios
      .put(datailUrl, nmData, {
        headers: {
          "Content-Type": headerType,
        },
        params: {
          auth_key: token,
          user_id: userId,
        },
      })
      .then(async (response) => {
        await this.setState({ dataLoading: false });
        if (response.data.status == 200) {
          AlertMessage(
            {
              message: this.props.t("reportEditedSuccessfully"),
              type: "success",
            },
            this._redirectToDetail,
          );
        } else {
          AlertMessage({
            message: this.props.t("editReportFailedTryAgain"),
            type: "error",
          });
        }
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
        AlertMessage({
          message: error.response.data?.msg || error,
          type: "error",
        });
      });
  };

  checkLowStorage = () => {
    return import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.reportSetting.checkStorage,
      );

      return responseObj;
    });
  };

  _handleLowSpace = async (statusFlag) => {
    await this.setState({ showLowStoragePopup: false });
  };

  _fetchOptionList = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");
    const tempSpringToken = localStorage.getItem("springToken");
    let token1 = localStorage.getItem("springToken");
    let requestData = {
      auth_key: token,
      user_id: userId,
      service_id: this.state.serviceId,
      project_id: this.state.projectId,
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    axios
      .all([
        // Department list
        axios.post(DEPT_URL, qs.stringify(requestData), {
          params: { auth_key: token1, used_id: userId },
          headers: ContentType,
        }),
        // Contractor List
        axios.post(CONT_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        // Zone List
        axios.post(ZONE_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        // Activity List
        axios.post(ACT_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        // Hazard List
        // axios.post(HZD_URL, qs.stringify(requestData), {
        //   headers: ContentType,
        // }),
        // Barrier List
        axios.post(BARRIER_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        //division list
        axios.post(
          Div_URL,
          qs.stringify({ ...requestData, auth_key: tempSpringToken }),
          {
            headers: ContentType,
          },
        ),
      ])
      .then(
        axios.spread(
          async (department, contractor, zone, activity, barrier, division) => {
            await this.setState((prevState) => {
              let {
                contractorList,
                departmentList,
                zoneList,
                //hazardList,
                activityList,
                barrierList,
                divisionList,
              } = prevState;

              departmentList =
                department.data.status === 200 ? department.data.data : [];
              contractorList =
                contractor.data.status === 200 ? contractor.data.data : [];
              zoneList = zone.data.status === 200 ? zone.data.data : [];
              //hazardList = hazard.data.status === 200 ? hazard.data.data : [];
              activityList =
                activity.data.status === 200 ? activity.data.data : [];
              barrierList =
                barrier.data.status === 200 ? barrier.data.data : [];
              divisionList =
                division.data.status === 200 ? division.data.data : [];
              //  dataLoading = false;
              return {
                contractorList,
                departmentList,
                zoneList,
                // hazardList,
                activityList,
                barrierList,
                divisionList,
              };
            });

            // await this._severityChangeHandle(this.state.selectedSeverity)
            await this._activityChangeHandle(
              this.state.selectedActivity,
              false,
            );
            // await this._subActivityChangeHandle(
            //   this.state.selectedSubActivity,
            //   true,
            // );
            await this._barrierChangeHandle(this.state.selectedBarrier);

            // await this._subHazardChangeHandle(
            //   this.state.selectedSubHazardId,
            //   true,
            // );
            await this._departmentChangeHandle(this.state.selectedDepartmentId);
            await this._contractorChangeHandle(this.state.selectedContractorId);
            await this._zoneChangeHandle(this.state.selectedZoneId);
            await this._locationChangeHandle(this.state.selectedLocationId);
          },
        ),
      )
      .catch((error) => {
        this._setDataLoading(false);
      });
  };

  _zoneChangeHandle = async (zoneId) => {
    await this.setState((prevState) => {
      let { selectedZoneId } = prevState;
      selectedZoneId = zoneId;
      //zoneError = zoneId ? false : true;
      return { selectedZoneId };
    });
    await this._fetchLocationList();
  };

  _fetchLocationList = async (zoneId) => {
    let requestData = {
      auth_key: token,
      user_id: userId,
      service_id: this.state.serviceId,
      project_id: this.state.projectId,
      zone_id: this.state.selectedZoneId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.locationList,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { locationList } = prevState;
              locationList = response.data.data;
              return { locationList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  fetchHazrdList = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      activity_id: this.state.selectedActivity,
    };

    let URL = Url.hazardList;

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    await axios
      .post(URL, qs.stringify(requestData), ContentType)
      .then(async (response) => {
        if (response.data.status == 200) {
          await this.setState({
            hazardList: response.data.data,
          });
        }
      })
      .catch(async (error) => {
        await this.setState({
          dataLoading: false,
        });
      });
  };

  _fetchSubHazardList = async () => {
    let requestData = {
      auth_key: token,
      user_id: userId,
      hazard_Id: this.state.selectedHazardId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.subhazardList,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { subHazardList } = prevState;
              subHazardList = response.data.data;
              return { subHazardList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _departmentChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedDepartmentId } = prevState;
      selectedDepartmentId = id;
      //departmentError = id ? false : true;
      return { selectedDepartmentId };
    });
  };

  _divisionChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedDivisionId, divisionError } = prevState;
      selectedDivisionId = id;
      divisionError = id ? false : true;
      return { selectedDivisionId, divisionError };
    });
    await this._fetchDepartmentList();
  };

  _fetchDepartmentList = async () => {
    let requestData = {
      // service_id: this.state.selectedServiceId,
      // project_id: this.state.selectedProjectId,
      divisionId: this.state.selectedDivisionId,
      service_id: this.state.reportDetail?.service_id,
      project_id: this.state.reportDetail?.project_id,

      // zone_id: zoneId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpring(
        DEPT_URL,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { departmentList } = prevState;
              departmentList = response.data.data;
              return { departmentList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _locationChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedLocationId } = prevState;
      selectedLocationId = id;
      //locationError = id ? false : true;
      return { selectedLocationId };
    });
  };

  _subHazardChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSubHazardId } = prevState;
      selectedSubHazardId = id;
      //subHazardError = id ? false : true;
      return { selectedSubHazardId, isSubHazardInvalid: false };
    });

    // UAUC + organisation setting ON -> control measures come from the selected sub-hazard node
    // if (this._isRiskRegisterMode()) {
    //   const hz = this._currentRrHazards().find(
    //     (h) => h.hazardId == this.state.selectedHazardId,
    //   );
    //   const sh = (hz?.subHazards || []).find((s) => s.subHazardId == id);
    //   await this.setState({
    //     controlMeasureList: this._mapRrControlMeasures(sh),
    //     selectedControlMeasureIds: [],
    //   });
    // }
  };

  _barrierChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedBarrier } = prevState;
      selectedBarrier = id;
      return { selectedBarrier };
    });
  };

  _mapRrHazards = (arr) =>
    (arr || []).map((h) => ({ name: h.hazardName, id: h.hazardId }));

  _mapRrSubHazards = (arr) =>
    (arr || []).map((sh) => ({ name: sh.subHazardName, id: sh.subHazardId }));

  _fetchRiskRegisterByActivity = async (activityId, isUserChange = false) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("springToken");
    try {
      const response = await axios.get(Url.riskRegisterByActivity, {
        params: { user_id: userId, auth_key: token, activityId },
        headers: { accept: "application/json" },
      });
      const data = response?.data?.data || null;
      const subActivities = data?.subActivities || [];
      const subActivityList = subActivities.map((sa) => ({
        name: sa.subActivityName,
        id: sa.subActivityId,
      }));

      if (isUserChange) {
        this.setState({
          riskRegisterTree: data,
          subActivityList,
          selectedSubActivity: null,
          subActivityError: false,
          hazardList: subActivities.length
            ? []
            : this._mapRrHazards(data?.hazards),
          selectedHazardId: null,
          subHazardList: [],
          selectedSubHazardId: null,
          controlMeasureList: [],
          selectedControlMeasureIds: [],
        });
        return;
      }

      const existingSubActivityId = this.state.selectedSubActivity;
      const subActivityMatch = subActivities.find(
        (sa) => sa.subActivityId == existingSubActivityId,
      );

      const hazardsSource = subActivities.length
        ? subActivityMatch?.hazards || []
        : data?.hazards || [];

      const existingHazardId = this.state.selectedHazardId;
      const hazardNode = hazardsSource.find(
        (h) => h.oldHazardId == existingHazardId,
      );
      const subHazards = hazardNode?.subHazards || [];

      const existingSubHazardId = this.state.selectedSubHazardId;
      const subHazardNode = subHazards.find(
        (sh) => sh.oldSubHazardId == existingSubHazardId,
      );

      await this.setState({
        riskRegisterTree: data,
        subActivityList,
        hazardList: this._mapRrHazards(hazardsSource),
        subHazardList: this._mapRrSubHazards(subHazards),

        selectedHazardId: hazardNode ? hazardNode.hazardId : existingHazardId,
        selectedSubHazardId: subHazardNode
          ? subHazardNode.subHazardId
          : existingSubHazardId,
      });
    } catch (error) {}
  };

  _activityChangeHandle = async (id, isUserChange = false) => {
    this.setState((prevState) => {
      let { selectedActivity } = prevState;
      selectedActivity = id;
      return { selectedActivity, activityError: false };
    });

    if (this._isRiskRegisterMode()) {
      await this._fetchRiskRegisterByActivity(id, isUserChange);
      return;
    }
    if (isUserChange) {
      this.setState({
        selectedHazardId: null,
        selectedSubHazardId: null,
        subHazardList: [],
      });
    }
    await this.fetchHazrdList(id);
  };

  _subActivityChangeHandle = async (id) => {
    const sa = (this.state.riskRegisterTree?.subActivities || []).find(
      (s) => s.subActivityId == id,
    );
    await this.setState({
      selectedSubActivity: id,
      subActivityError: id ? false : true,
      hazardList: this._mapRrHazards(sa?.hazards),
      selectedHazardId: null,
      subHazardList: [],
      selectedSubHazardId: null,
      controlMeasureList: [],
      selectedControlMeasureIds: [],
    });
  };

  _hazardChangeHandle = async (hazardId) => {
    const isHazardInvalid =
      this.isEmpty(hazardId) || hazardId === "0" || hazardId === 0;
    await this.setState((prevState) => {
      let { selectedHazardId } = prevState;
      selectedHazardId = hazardId;
      return {
        selectedHazardId,
        selectedSubHazardId: null,
        isHazardInvalid,
      };
    });

    if (this._isRiskRegisterMode()) {
      const hz = this._currentRrHazards().find((h) => h.hazardId == hazardId);
      const subHazards = hz?.subHazards || [];
      await this.setState({
        subHazardList: this._mapRrSubHazards(subHazards),
        selectedSubHazardId: null,
      });
      return;
    }

    await this._fetchSubHazardList(hazardId);
    debugger;
  };

  // Hazards for the current selection: under the chosen sub-activity, else directly under the activity.
  _currentRrHazards = () => {
    const tree = this.state.riskRegisterTree;
    if (!tree) return [];
    if (tree.subActivities && tree.subActivities.length) {
      const sa = tree.subActivities.find(
        (s) => s.subActivityId == this.state.selectedSubActivity,
      );
      return sa?.hazards || [];
    }
    return tree.hazards || [];
  };

  _contractorChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedContractorId } = prevState;
      selectedContractorId = id;
      //contractorError = id ? false : true;
      return { selectedContractorId };
    });
  };

  _typeactChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedTypeAct } = prevState;
      selectedTypeAct = id;
      return { selectedTypeAct };
    });
  };

  _severityChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSeverity } = prevState;
      selectedSeverity = id;
      return { selectedSeverity };
    });
  };

  _handleChange = async (item = null, type = "observation") => {
    await this.setState((prevState) => {
      switch (type) {
        case "observation":
          let { observationText, observationError, observationURL } = prevState;
          observationText = item;
          observationError = !observationURL && !item ? true : false;
          return { observationText, observationError };
          break;
        case "incidentpersonname":
          let { incidentPersonName, incidentPersonError } = prevState;
          incidentPersonName = item;
          incidentPersonError = !incidentPersonName && !item ? true : false;
          return { incidentPersonName, incidentPersonError };
          break;
        case "control_measure":
          let { controlMeasure } = prevState;
          controlMeasure = item;
          return { controlMeasure };
          break;
        case "target_date":
          let { selectedTargetDate } = prevState;
          selectedTargetDate = item;
          return { selectedTargetDate };
          break;
        case "incident_date":
          let { selectedIncidentDate } = prevState;
          selectedIncidentDate = item;
          return { selectedIncidentDate };
          break;
        case "person_name":
          let { personName, personNameError } = prevState;
          personName = item;
          personNameError = item ? false : true;
          return { personName, personNameError };
          break;
        case "resolve_checkbox":
          let { resolveCheckbox } = prevState;
          resolveCheckbox = item ? 1 : 0;
          return { resolveCheckbox };
          break;
        default:
          return prevState;
          break;
      }
    });
  };

  _removeAudioFile = async (type) => {
    await this.setState((prevState) => {
      let {
        observationAudio,
        observationURL,
        controlMeasureAudio,
        controlMeasureURL,
        controlMeasureFileStatus,
        observationFileStatus,
      } = prevState;

      if (type === "observation") {
        observationAudio = "";
        observationURL = "";
        observationFileStatus = 1;
      }

      if (type === "control_measure") {
        controlMeasureAudio = "";
        controlMeasureURL = "";
        controlMeasureFileStatus = 1;
      }
      return {
        observationAudio,
        observationURL,
        controlMeasureAudio,
        controlMeasureURL,
        controlMeasureFileStatus,
        observationFileStatus,
      };
    });
  };

  removeInviteUser = async (selectedUserId) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.smDashboard.removeInviteUser,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          report_id: this.state.nmId,
          selected_user_id: selectedUserId,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          AlertMessage({
            message: this.props.t("userRemovedSuccessfully"),
            type: "success",
          });
          this.reportDetail();
        } else {
          AlertMessage({
            message: this.props.t("userNotRemovedPleaseTryAgain"),
            type: "error",
          });
        }
      })
      .catch((error) => {});
  };

  _addUsersToList = async (newUsers) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");
    const reportId = this.state.nmId;
    var selectedUserIds = [];
    newUsers.map((item, key) => selectedUserIds.push(item.user_id));

    var data = {
      auth_key: token,
      user_id: userId,
      report_id: reportId,
      selected_user_id: selectedUserIds,
    };

    var formBody = [];
    for (var property in data) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(data[property]);

      if (property == "selected_user_id") {
        data[property].map((item, key) =>
          formBody.push(encodedKey + "=" + item),
        );
      } else {
        formBody.push(encodedKey + "=" + encodedValue);
      }
    }
    formBody = formBody.join("&");

    await axios
      .post(Url.smDashboard.addInviteUser, formBody, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })

      .then((response) => {
        if (response.data.status == 200) {
          AlertMessage({
            message: this.props.t("userAddedSuccessfully"),
            type: "success",
          });
          this.reportDetail();
        } else {
          AlertMessage({
            message: this.props.t("userNotAddedTryAgain"),
            type: "error",
          });
        }
      })
      .catch((error) => {});
  };

  cancelItem_onClick = () => {
    this.props.history.goBack();
    //window.history.back();
  };

  _showRecorder = async (flag = false, type = "observation") => {
    await this.setState((prevState) => {
      let { showRecorderModal, recordingFor } = prevState;
      showRecorderModal = flag;
      recordingFor = type;
      return { showRecorderModal, recordingFor };
    });
  };

  startRecording = async () => {
    await this.setState({ recordAudio: true });
  };

  stopRecording = async () => {
    await this.setState({ recordAudio: false });
  };

  onStop = async (recordedBlob) => {
    let promise = new Promise((resolve, error) => {
      let reader = new FileReader();
      reader.readAsDataURL(recordedBlob.blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });

    promise.then(async (response) => {
      await this.setState((prevState) => {
        let {
          recordingFor,
          controlMeasureAudio,
          controlMeasureURL,
          observationAudio,
          observationURL,
          controlMeasureFileStatus,
          observationFileStatus,
        } = prevState;

        if (recordingFor === "control_measure") {
          controlMeasureAudio = recordedBlob.blob;
          controlMeasureURL = response;
          controlMeasureFileStatus = 2;
        }
        if (recordingFor === "observation") {
          observationAudio = recordedBlob.blob;
          observationURL = response;
          observationFileStatus = 2;
        }
        return {
          recordingFor,
          controlMeasureAudio,
          controlMeasureURL,
          observationAudio,
          observationURL,
          controlMeasureFileStatus,
          observationFileStatus,
        };
      });
    });
  };

  _removeAudioFile = async (type) => {
    await this.setState((prevState) => {
      if (type === "observation") {
        prevState.observationAudio = "";
        prevState.observationURL = "";
        return prevState;
      }

      if (type === "control_measure") {
        prevState.controlMeasureAudio = "";
        prevState.controlMeasureURL = "";
        return prevState;
      }
    });
  };

  _removeImageFile = async (value, type) => {
    if (type == "exist") {
      var array = this.state.evidenceImage;

      //added by Tushar for handling multiple images and remove functionality
      var deleteEvidences = this.state.deletedEvidencesIds;
      deleteEvidences.push(array[value].evidence_id);
      // var index = array.indexOf(value);
      array.splice(value, 1);
      this.setState({
        evidenceImage: array,
        deletedEvidencesIds: deleteEvidences,
      });
    }
    if (type == "new") {
      var array = this.state.reportDetailevidence;
      //added by Tushar for handling multiple images and remove functionality
      var files = this.state.files;
      // var index = array.indexOf(value);
      array.splice(value, 1);
      files.splice(value, 1);
      this.setState({ reportDetailevidence: array, files });
    }
  };

  _onTimeChange = async (options) => {
    const { hour, minute, meridiem } = options;

    //const time = `${hour}:${minute}:00`;

    const time = `${hour}:${minute}:00 ${meridiem}`;
    // const formattedTime = moment(time, "HH:mm:").format("hh:mm");

    const number = moment(time, ["h:mm A"]).format("HH:mm");
    console.log("number == " + number);

    console.log("time == " + time);
    // console.log("formattedTime == " +formattedTime);

    await this.setState({
      //selectedIncidentTime: formattedTime,
      selectedIncidentTime: number,
      selectedTimeMeridiem: meridiem,
    });
  };

  _handleImageChange = async (e) => {
    e.preventDefault();

    let fileObj = [];
    let fileArray = this.state.reportDetailevidence;
    let files = this.state.files;

    fileObj.push(e.target.files);

    const lowStorage = this.checkLowStorage();
    lowStorage
      .then(async (response) => {
        const { status, msg } = response.data;

        if (status == 200) {
          for (let i = 0; i < fileObj[0].length; i++) {
            fileArray.push(fileObj[0][i]);
            //added by Tushar for handling multiple images and remove functionality
            let obj = {
              file: fileObj[0][i],
              file_status: 1,
              file_id: "",
            };
            files.push(obj);
          }
          this.setState({ reportDetailevidence: fileArray, files });
          console.log(this.state.files);
        }
        await this.setState({
          lowStorageStatus: status,
          lowStorageMessage: msg,
          showLowStoragePopup: status == 200 ? false : true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  UserWhoLiked = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.smDashboard.dashboarddetaillikelist,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          report_id: this.state.nmId,
          report_type: "nm",
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            userLike: response.data.data,
            likeNumber: response.data.like_number,
          });
        }
      })
      .catch((error) => {});
  };

  addIncidentPerson = () => {
    if (this.state.injuredPersonName) {
      console.log("persons == " + this.state.injuredPersonName);

      let tempIncidentPersons = [...this.state.incidentPersons];
      const tempData = {
        incident_person_name: this.state.injuredPersonName.trim(),
        incident_person_id: this.state.injuredPersonID,
        status: "Created",
      };

      let newValue = [...tempIncidentPersons, tempData];
      this.setState({
        incidentPersons: newValue,
        injuredPersonName: "",
        injuredPersonID: "",
        incidentPersonNameError: false,
      });
    } else {
      ErrorToast("Please enter valid incident person name");
    }
  };

  _deletePersonName = async (deletePersonId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      personId: deletePersonId,
    };

    let URL = Url.nmModule.deleteIncidentPerson;
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    await axios
      .post(URL, qs.stringify(requestData), ContentType)
      .then(async (response) => {
        if (response.data.status === 200) {
          let tempIncidentPerson = [...this.state.incidentPersons];
          let newData = tempIncidentPerson.filter(
            (item) => item.personId !== deletePersonId,
          );

          tempIncidentPerson = newData;
          this.setState({
            incidentPersons: tempIncidentPerson,
          });
        }
      })
      .catch((error) => {
        AlertMessage({
          message: this.props.t("incidentPersonIdnotDeleted"),
          type: "error",
        });
      });
  };

  // _removePerson = (index) => {
  //   let updateIncidentPersons = this.state.incidentPersons.map((el, ind) => {
  //     if (ind === index) {
  //       el = {
  //         ...el,
  //         status: "Deleted",
  //       };
  //     }
  //     return el;
  //   });

  //   this.setState({
  //     incidentPersons: updateIncidentPersons,
  //   });
  // };

  _removePerson = async (index) => {
    const updateIncidentPersons = this.state.incidentPersons.filter(
      (_, ind) => ind !== index,
    );
    this.setState({
      incidentPersons: updateIncidentPersons,
    });
  };

  handleEditPersonName = async (event = "", index = 0, moduleName) => {
    let name = event.target.value;
    let tempIncidentPersons = [...this.state.incidentPersons];

    let item = tempIncidentPersons[index];
    item[moduleName] = name;
    if (Object.hasOwn(item, "person_unique_record_id")) {
      item = {
        ...item,
        status: "Updated",
      };
    }
    tempIncidentPersons[index] = item;
    this.setState({
      incidentPersons: tempIncidentPersons,
    });
  };

  searchEmployee = async (inputString, callback) => {
    const params = {
      auth_key: localStorage.getItem("springToken"),
      projectId: this.state.projectId || this.state.selectedProjectId || null,
      user_id: localStorage.getItem("userId"),
      search: inputString,
    };
    const contentType = { "Content-Type": "application/x-www-form-urlencoded" };
    await axios
      .get(Url.userSearch, {
        headers: contentType,
        params,
      })
      .then(async (response) => {
        if (response.data.status === 200) {
          callback(response.data);
          await this.setState({
            searchData: { ...this.state.searchData, ...response.data },
          });
        }
      })
      .catch((error) => {});
  };
  debounceFunc = _.debounce(function (callback) {
    callback();
  }, 300);

  render() {
    const { t } = this.props;
    var reportData = this.state.reportDetail;
    console.log("statedata ", this.state);
    const uaUcChart = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      title: null,
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          showInLegend: true,
        },
      },
      tooltip: {
        formatter: function () {
          return "<b>" + this.point.name + "</b>: " + this.y;
        },
      },
      series: [
        {
          data: [
            {
              y: reportData.activity_analysis?.ua_number,
              name: "Unsafe Act",
              color: "#C7AC83",
            },
            {
              y: reportData.activity_analysis?.uc_number,
              name: "Unsafe Condition",
              color: "#554040",
            },
          ],
          size: "100%",
          innerSize: "56%",
          dataLabels: {
            enabled: false,
          },
        },
      ],
    };

    const nmuaUcChart = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      title: null,
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          showInLegend: true,
        },
      },
      tooltip: {
        formatter: function () {
          return "<b>" + this.point.name + "</b>: " + this.y;
        },
      },
      series: [
        {
          data: [
            {
              y: reportData.activity_analysis?.nm_ua_number,
              name: "Unsafe Act",
              color: reportData.activity_analysis?.nm_ua_color,
            },
            {
              y: reportData.activity_analysis?.nm_uc_number,
              name: "Unsafe Condition",
              color: reportData.activity_analysis?.nm_uc_color,
            },
          ],
          size: "100%",
          innerSize: "56%",
          dataLabels: {
            enabled: false,
          },
        },
      ],
    };

    const analysisChart = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      title: null,
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          showInLegend: true,
        },
      },
      tooltip: {
        formatter: function () {
          return "<b>" + this.point.name + "</b>: " + this.y;
        },
      },
      series: [
        {
          data: [
            {
              y: reportData.activity_analysis?.fa_number || 0,
              name: "FA",
              color: "#FF4242",
            },
            {
              y: reportData.activity_analysis?.rta_number || 0,
              name: "RTA",
              color: "#086992",
            },
            {
              y: reportData.activity_analysis?.mtc_number || 0,
              name: "MTC",
              color: "#FAAC15",
            },
            {
              y: reportData.activity_analysis?.lti_number || 0,
              name: "LTI",
              color: "#18DA07",
            },
          ],
          size: "100%",
          innerSize: "56%",
          dataLabels: {
            enabled: false,
          },
        },
      ],
    };
    console.log("selectedHazardId ", this.state.selectedHazardId);
    console.log("hazardList ", this.state.hazardList);

    return (
      <>
        {/* Data Loading  */}
        <div
          className="loader"
          style={{ display: this.state.dataLoading ? "block" : "none" }}
        >
          <LoadingImage />
        </div>
        <div className="row  clide-v2-colume_title ">
          <div className="mb-1 clide-v2-fs-3 fw-bold">{t("nmEdit")} </div>

          <div className="row my-4 align-items-center">
            <div className="col-12 col-lg-4 col-md-4 px-0">
              <Link
                to={{
                  pathname: `/nm-detail/${reportData.nm_id}/kanban/pending`,
                }}
              >
                <Button
                  className="border clide-v2-primary clide-v2-white-color"
                  variant=""
                >
                  <i className="fa fa-angle-left" aria-hidden="true"></i>
                </Button>
              </Link>
            </div>
            <div className="col-12 col-lg-4 col-md-4 text-center">
              <span>{reportData.activity}</span>
            </div>
            <div className="col-12 col-lg-4 col-md-4 d-flex justify-content-end px-0">
              <div className="d-flex align-items-center">
                <button
                  className="clide-v2-icon-btn mr-2"
                  title="Save"
                  onClick={() =>
                    this.debounceFunc(() => {
                      this.EditreportDetail();
                    })
                  }
                >
                  <RoundSave />
                </button>
                <button
                  className="clide-v2-icon-btn mr-2"
                  title="Cancel"
                  onClick={() =>
                    this.debounceFunc(() => {
                      this.cancelItem_onClick();
                    })
                  }
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16"
                      cy="16"
                      r="15.5"
                      fill="white"
                      stroke="#FF6347"
                    />
                    <path
                      d="M17.2727 16L20.8352 12.4375C21.0043 12.2687 21.0994 12.0397 21.0996 11.8008C21.0998 11.5619 21.0051 11.3327 20.8364 11.1636C20.6676 10.9945 20.4386 10.8994 20.1997 10.8992C19.9608 10.899 19.7316 10.9937 19.5625 11.1625L16 14.725L12.4375 11.1625C12.2684 10.9934 12.0391 10.8984 11.8 10.8984C11.5609 10.8984 11.3316 10.9934 11.1625 11.1625C10.9934 11.3316 10.8984 11.5609 10.8984 11.8C10.8984 12.0391 10.9934 12.2684 11.1625 12.4375L14.725 16L11.1625 19.5625C10.9934 19.7316 10.8984 19.9609 10.8984 20.2C10.8984 20.4391 10.9934 20.6684 11.1625 20.8375C11.3316 21.0066 11.5609 21.1016 11.8 21.1016C12.0391 21.1016 12.2684 21.0066 12.4375 20.8375L16 17.275L19.5625 20.8375C19.7316 21.0066 19.9609 21.1016 20.2 21.1016C20.4391 21.1016 20.6684 21.0066 20.8375 20.8375C21.0066 20.6684 21.1016 20.4391 21.1016 20.2C21.1016 19.9609 21.0066 19.7316 20.8375 19.5625L17.2727 16Z"
                      fill="#FF6347"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="row my-4 ">
              <div className="col-12 col-md-9 col-lg-9">
                <div className="clide-v2-card-box-1">
                  <div className="d-flex align-items-center">
                    <div className="fullWidth eight columns">
                      <ul className="cbp_tmtimeline">
                        <li>
                          <div className="cbp_tmicon cbp_tmicon-phone">
                            <svg
                              width={40}
                              height={40}
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M33.1716 14.3097C33.0926 14.1288 32.982 13.9634 32.845 13.8213L22.845 3.82134C22.7029 3.68431 22.5375 3.57369 22.3566 3.49467C22.3066 3.47134 22.2533 3.45801 22.2 3.43967C22.0605 3.39222 21.9153 3.36363 21.7683 3.35467C21.7333 3.35134 21.7016 3.33301 21.6666 3.33301H9.99996C8.16163 3.33301 6.66663 4.82801 6.66663 6.66634V33.333C6.66663 35.1713 8.16163 36.6663 9.99996 36.6663H30C31.8383 36.6663 33.3333 35.1713 33.3333 33.333V14.9997C33.3333 14.9647 33.315 14.933 33.3116 14.8963C33.3035 14.7492 33.2749 14.6039 33.2266 14.4647C33.21 14.4113 33.195 14.3597 33.1716 14.3097ZM27.6433 13.333H23.3333V9.02301L27.6433 13.333ZM9.99996 33.333V6.66634H20V14.9997C20 15.4417 20.1756 15.8656 20.4881 16.1782C20.8007 16.4907 21.2246 16.6663 21.6666 16.6663H30L30.0033 33.333H9.99996Z"
                                fill="white"
                              />
                              <path
                                d="M13.3334 19.9997H26.6667V23.333H13.3334V19.9997ZM13.3334 26.6663H26.6667V29.9997H13.3334V26.6663ZM13.3334 13.333H16.6667V16.6663H13.3334V13.333Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12 ">
                                <div className="row">
                                  <div className="col-6 px-0">
                                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold  pt-3">
                                      {t("activityInfo")}
                                    </p>
                                  </div>
                                  <div className="col-6 px-0 d-flex-center gap-2 ">
                                    <div
                                      className="severity-box border-0 clide-v2-icon "
                                      style={{
                                        backgroundColor:
                                          reportData.severity_color,
                                        width: "20px",
                                        height: "20px",
                                      }}
                                    ></div>
                                    <select
                                      value={this.state.selectedSeverity}
                                      className="form-control mb-0"
                                      onChange={(event) =>
                                        this._severityChangeHandle(
                                          event.target.value,
                                        )
                                      }
                                    >
                                      <option>{t("selectRiskLevel")}</option>
                                      {SEVERITY.map((item, index) => (
                                        <option key={index} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>

                                <div className="row">
                                  {this.state.organisationSetting && (
                                    <div className="col mb-2">
                                      <div className="col-12 col-md-12 col-lg-12 px-0">
                                        <div className="clide-v2-title mb-1">
                                          <label className="clide-v2-fs-4 mb-0">
                                            {t("companyName")}
                                          </label>
                                        </div>
                                      </div>
                                      <div className="clide-v2-title mb-1">
                                        <label className="">
                                          <div className="output-text">
                                            {reportData.companyName}
                                          </div>
                                        </label>
                                      </div>
                                    </div>
                                  )}

                                  <div className="col mb-2">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("service")}
                                        </label>
                                      </div>
                                    </div>

                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        <div className="output-text">
                                          {reportData.service}
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                  {this.state.organisationSetting && (
                                    <div className="col mb-2">
                                      <div className="col-12 col-md-12 col-lg-12 px-0">
                                        <div className="clide-v2-title mb-1">
                                          <label className="clide-v2-fs-4 mb-0">
                                            Project Category
                                          </label>
                                        </div>
                                      </div>
                                      <div className="clide-v2-title mb-1">
                                        <label className="">
                                          {reportData.projectCategoryName}
                                        </label>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col mb-2">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("plantProject")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.project}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 ">
                                <div className="row">
                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "type of act",
                                  ) ? (
                                    <div className="col-lg-4 col-md-4 px-2">
                                      <div className="col-12  px-0">
                                        <div className="clide-v2-title mb-1 ">
                                          <label className="clide-v2-fs-4 mb-0 ">
                                            {t("typeOfAct")}
                                          </label>
                                        </div>
                                      </div>
                                      <div className="slds-select_container">
                                        <Select
                                          styles={customSelectStyles}
                                          classNamePrefix="clide-searchable-select"
                                          value={
                                            this.state.typeActList
                                              .map((item) => ({
                                                value: item.id,
                                                label: item.name,
                                              }))
                                              .find(
                                                (item) =>
                                                  item.value ===
                                                  this.state.selectedTypeAct,
                                              ) || null
                                          }
                                          onChange={(selectedOption) =>
                                            this._typeactChangeHandle(
                                              selectedOption
                                                ? selectedOption.value
                                                : "0",
                                            )
                                          }
                                          options={[
                                            // {
                                            //   value: "0",
                                            //   label: t("selectType"),
                                            // },
                                            ...this.state.typeActList.map(
                                              (item) => ({
                                                value: item.id,
                                                label: item.name,
                                              }),
                                            ),
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  ) : null}
                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "activity",
                                  ) ? (
                                    <div className="col-lg-4 col-md-4 px-2">
                                      <CommonDropdown
                                        title={t("activity")}
                                        optionList={this.state.activityList}
                                        onChangeHandle={(val) =>
                                          this._activityChangeHandle(val, true)
                                        }
                                        value={this.state.selectedActivity}
                                        hasError={this.state.activityError}
                                        searchable={true}
                                        customSelectStyles={customSelectStyles}
                                        customStyle={true}
                                      />
                                    </div>
                                  ) : null}

                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "sub activity",
                                  ) ? (
                                    <div className="col-lg-4 col-md-4 px-2">
                                      <CommonDropdown
                                        title="Sub Activity"
                                        optionList={this.state.subActivityList}
                                        onChangeHandle={
                                          this._subActivityChangeHandle
                                        }
                                        isRequired={true}
                                        value={this.state?.selectedSubActivity}
                                        hasError={this.state?.subActivityError}
                                        searchable={true}
                                        customSelectStyles={customSelectStyles}
                                        customStyle={true}
                                      />
                                    </div>
                                  ) : null}

                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "hazard",
                                  ) ? (
                                    <div className="col-lg-4 col-md-4 px-2">
                                      <CommonDropdown
                                        title={t("hazard")}
                                        optionList={this.state.hazardList}
                                        onChangeHandle={
                                          this._hazardChangeHandle
                                        }
                                        isRequired
                                        value={this.state.selectedHazardId}
                                        hasError={this.state.isHazardInvalid}
                                        searchable={true}
                                        customSelectStyles={customSelectStyles}
                                        customStyle={"true"}
                                      />
                                    </div>
                                  ) : null}

                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "sub hazard",
                                  ) ? (
                                    <div className="col-lg-4 col-md-4 px-2">
                                      <CommonDropdown
                                        title={t("subHazard")}
                                        optionList={this.state.subHazardList}
                                        onChangeHandle={
                                          this._subHazardChangeHandle
                                        }
                                        isRequired
                                        value={this.state.selectedSubHazardId}
                                        hasError={this.state.isSubHazardInvalid}
                                        searchable={true}
                                        customSelectStyles={customSelectStyles}
                                        customStyle={"true"}
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="cbp_tmicon cbp_tmicon-phone">
                            <svg
                              width={40}
                              height={40}
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M33.1716 14.3097C33.0926 14.1288 32.982 13.9634 32.845 13.8213L22.845 3.82134C22.7029 3.68431 22.5375 3.57369 22.3566 3.49467C22.3066 3.47134 22.2533 3.45801 22.2 3.43967C22.0605 3.39222 21.9153 3.36363 21.7683 3.35467C21.7333 3.35134 21.7016 3.33301 21.6666 3.33301H9.99996C8.16163 3.33301 6.66663 4.82801 6.66663 6.66634V33.333C6.66663 35.1713 8.16163 36.6663 9.99996 36.6663H30C31.8383 36.6663 33.3333 35.1713 33.3333 33.333V14.9997C33.3333 14.9647 33.315 14.933 33.3116 14.8963C33.3035 14.7492 33.2749 14.6039 33.2266 14.4647C33.21 14.4113 33.195 14.3597 33.1716 14.3097ZM27.6433 13.333H23.3333V9.02301L27.6433 13.333ZM9.99996 33.333V6.66634H20V14.9997C20 15.4417 20.1756 15.8656 20.4881 16.1782C20.8007 16.4907 21.2246 16.6663 21.6666 16.6663H30L30.0033 33.333H9.99996Z"
                                fill="white"
                              />
                              <path
                                d="M13.3334 19.9997H26.6667V23.333H13.3334V19.9997ZM13.3334 26.6663H26.6667V29.9997H13.3334V26.6663ZM13.3334 13.333H16.6667V16.6663H13.3334V13.333Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12 ">
                                <div className="row">
                                  <div className="col-12 px-0">
                                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold  pt-3">
                                      {t("aboutIncident")}
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "incident date",
                                  ) ? (
                                    <div className="col col-lg-4 col-md-4">
                                      <div className="col-12  px-0">
                                        <div className="clide-v2-title mb-1 ">
                                          <label className="clide-v2-fs-4 mb-0 ">
                                            {t("incidentDate")}
                                          </label>
                                        </div>
                                      </div>
                                      <div class="d-flex flex-direction-m">
                                        <div class="input-group mb-3  w-100">
                                          <DatePicker
                                            selected={
                                              this.state.selectedIncidentDate
                                            }
                                            dateFormat="dd/MM/yyyy"
                                            maxDate={this.state.selectedOldDate}
                                            placeholderText="DD-MM-YYYY"
                                            className="form-control "
                                            wrapperClassName="flex-grow-1"
                                            onChange={(jsDate) =>
                                              this._handleChange(
                                                jsDate,
                                                "incident_date",
                                              )
                                            }
                                          />
                                          <button
                                            class="btn btn-secondary clide-v2-bg-white clide-v2-border-color border-start-0"
                                            type="button"
                                            id="button-addon2"
                                          >
                                            <svg
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M12.6668 2.66634H11.3335V1.99967C11.3335 1.82286 11.2633 1.65329 11.1382 1.52827C11.0132 1.40325 10.8436 1.33301 10.6668 1.33301C10.49 1.33301 10.3204 1.40325 10.1954 1.52827C10.0704 1.65329 10.0002 1.82286 10.0002 1.99967V2.66634H6.00016V1.99967C6.00016 1.82286 5.92992 1.65329 5.8049 1.52827C5.67988 1.40325 5.51031 1.33301 5.3335 1.33301C5.15668 1.33301 4.98712 1.40325 4.86209 1.52827C4.73707 1.65329 4.66683 1.82286 4.66683 1.99967V2.66634H3.3335C2.80306 2.66634 2.29436 2.87705 1.91928 3.25213C1.54421 3.6272 1.3335 4.13591 1.3335 4.66634V12.6663C1.3335 13.1968 1.54421 13.7055 1.91928 14.0806C2.29436 14.4556 2.80306 14.6663 3.3335 14.6663H12.6668C13.1973 14.6663 13.706 14.4556 14.081 14.0806C14.4561 13.7055 14.6668 13.1968 14.6668 12.6663V4.66634C14.6668 4.13591 14.4561 3.6272 14.081 3.25213C13.706 2.87705 13.1973 2.66634 12.6668 2.66634ZM13.3335 12.6663C13.3335 12.8432 13.2633 13.0127 13.1382 13.1377C13.0132 13.2628 12.8436 13.333 12.6668 13.333H3.3335C3.15668 13.333 2.98712 13.2628 2.86209 13.1377C2.73707 13.0127 2.66683 12.8432 2.66683 12.6663V7.99967H13.3335V12.6663ZM13.3335 6.66634H2.66683V4.66634C2.66683 4.48953 2.73707 4.31996 2.86209 4.19494C2.98712 4.06991 3.15668 3.99967 3.3335 3.99967H4.66683V4.66634C4.66683 4.84315 4.73707 5.01272 4.86209 5.13775C4.98712 5.26277 5.15668 5.33301 5.3335 5.33301C5.51031 5.33301 5.67988 5.26277 5.8049 5.13775C5.92992 5.01272 6.00016 4.84315 6.00016 4.66634V3.99967H10.0002V4.66634C10.0002 4.84315 10.0704 5.01272 10.1954 5.13775C10.3204 5.26277 10.49 5.33301 10.6668 5.33301C10.8436 5.33301 11.0132 5.26277 11.1382 5.13775C11.2633 5.01272 11.3335 4.84315 11.3335 4.66634V3.99967H12.6668C12.8436 3.99967 13.0132 4.06991 13.1382 4.19494C13.2633 4.31996 13.3335 4.48953 13.3335 4.66634V6.66634Z"
                                                fill="#FF6347"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "incident time",
                                  ) ? (
                                    <div className="col col-lg-4 col-md-4">
                                      <div className="col-12  px-0">
                                        <div className="clide-v2-title mb-1 ">
                                          <label className="clide-v2-fs-4 mb-0 ">
                                            {t("incidentTime")}
                                          </label>
                                        </div>
                                      </div>
                                      <div className="calender-div slds-form-element__control">
                                        <TimePicker
                                          timeMode="12"
                                          onTimeChange={(timeOptions) =>
                                            this._onTimeChange(timeOptions)
                                          }
                                          time={this.state.selectedIncidentTime}
                                          closeOnOutsideClick={false}
                                          meridiem={
                                            this.state.selectedTimeMeridiem
                                          }
                                        />
                                      </div>
                                    </div>
                                  ) : null}
                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "Employee Search",
                                  ) ? (
                                    <div className="col ">
                                      <div className="col-12  px-0">
                                        <div className="clide-v2-title mb-1 ">
                                          <label className="clide-v2-fs-4 mb-0 ">
                                            {t("searchEmployee")}
                                          </label>
                                        </div>
                                      </div>
                                      <div>
                                        <AsyncSelect
                                          isMulti
                                          cacheOptions
                                          onChange={(data) => {
                                            const items = data?.map((el) => {
                                              return {
                                                incident_person_id:
                                                  el?.employeeId,
                                                incident_person_name: el?.label,
                                                status: "Created",
                                                searched_incident_person_id:
                                                  el?.value,
                                              };
                                            });
                                            this.setState({
                                              searchFiledUsers: items,
                                            });
                                          }}
                                          placeholder={t("enterEmployeeName")}
                                          loadOptions={(input, callback) => {
                                            if (this.timeout)
                                              clearTimeout(this.timeout);
                                            this.timeout = setTimeout(() => {
                                              this.searchEmployee(
                                                input,
                                                (data) => {
                                                  const excudleIds =
                                                    this.state.incidentPersons?.map(
                                                      (el) => {
                                                        if (
                                                          el?.searched_incident_person_id &&
                                                          el?.status !==
                                                            "Deleted"
                                                        ) {
                                                          return el?.searched_incident_person_id?.toString();
                                                        }
                                                      },
                                                    );
                                                  const items = [];
                                                  data.data.forEach(
                                                    (element) => {
                                                      if (
                                                        !excudleIds.includes(
                                                          element?.id?.toString(),
                                                        )
                                                      ) {
                                                        items.push({
                                                          ...element,
                                                          label: element?.name,
                                                          value: element?.id,
                                                        });
                                                      }
                                                    },
                                                  );
                                                  callback(items);
                                                },
                                              );
                                            }, 1000);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ) : null}
                                  <Row className="px-0 mt-4">
                                    <Col className="px-0 ">
                                      <div className="feild-group">
                                        {this.state.incidentPersons.map(
                                          (data, index) => {
                                            return data?.status !==
                                              "Deleted" ? (
                                              <div
                                                key={index}
                                                className="row d-flex align-items-baseline"
                                              >
                                                <div className="col col-md-5 col-lg-5">
                                                  {CheckFormSettingField(
                                                    this.state.formSetting
                                                      ?.setting,
                                                    "person",
                                                  ) ? (
                                                    <div>
                                                      <div className="clide-v2-title mb-1 ">
                                                        <label className="clide-v2-fs-4 mb-0 w-space-nobreak">
                                                          {t(
                                                            "nameOfInjuredPerson",
                                                          )}
                                                        </label>
                                                      </div>
                                                      <input
                                                        type="text"
                                                        className="form-control mb-0"
                                                        value={
                                                          data?.incident_person_name
                                                        }
                                                        disabled={
                                                          data?.searched_incident_person_id
                                                        }
                                                        onChange={(event) =>
                                                          this.handleEditPersonName(
                                                            event,
                                                            index,
                                                            "incident_person_name",
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ) : null}
                                                </div>
                                                <div className="col col-md-5 col-lg-5">
                                                  {CheckFormSettingField(
                                                    this.state.formSetting
                                                      ?.setting,
                                                    "person id",
                                                  ) ? (
                                                    <div>
                                                      <div className="clide-v2-title mb-1 ">
                                                        <label className="clide-v2-fs-4 mb-0 w-space-nobreak ">
                                                          {t("id")}
                                                        </label>
                                                      </div>
                                                      <input
                                                        type="text"
                                                        className="form-control mb-0"
                                                        value={
                                                          data?.incident_person_id
                                                        }
                                                        disabled={
                                                          data?.searched_incident_person_id
                                                        }
                                                        onChange={(event) =>
                                                          this.handleEditPersonName(
                                                            event,
                                                            index,
                                                            "incident_person_id",
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ) : null}
                                                </div>
                                                <div className="col">
                                                  <XCircle
                                                    className="cursor-pointer mt-4"
                                                    onClick={() =>
                                                      this._removePerson(index)
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            ) : null;
                                          },
                                        )}
                                      </div>
                                    </Col>
                                    <Col className="d-flex align-items-end">
                                      <div className="row d-flex align-items-baseline">
                                        <div className="col col-md-5 col-lg-5">
                                          <input
                                            type="text"
                                            className={`form-control  mb-0  ${
                                              this.state.incidentPersonNameError
                                                ? "is-invalid"
                                                : "border"
                                            }`}
                                            value={this.state.injuredPersonName}
                                            placeholder={t("enterPersonName")}
                                            onChange={(event) =>
                                              this.setState({
                                                injuredPersonName:
                                                  event.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                        <div className="col col-md-5 col-lg-5">
                                          <input
                                            type="text"
                                            className={`form-control  mb-0 mx-2  ${
                                              this.state.incidentPersonNameError
                                                ? "is-invalid"
                                                : "border"
                                            }`}
                                            value={this.state.injuredPersonID}
                                            placeholder={t("enterId")}
                                            onChange={(event) =>
                                              this.setState({
                                                injuredPersonID:
                                                  event.target.value,
                                              })
                                            }
                                          />
                                          <ErrorBlock
                                            message={`Enter at least one incident peroson name`}
                                          />
                                        </div>

                                        <div className="col ">
                                          <PlusCircle
                                            className="cursor-pointer"
                                            onClick={() =>
                                              this.addIncidentPerson()
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="cbp_tmicon cbp_tmicon-phone">
                            <svg
                              width={40}
                              height={40}
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M33.1716 14.3097C33.0926 14.1288 32.982 13.9634 32.845 13.8213L22.845 3.82134C22.7029 3.68431 22.5375 3.57369 22.3566 3.49467C22.3066 3.47134 22.2533 3.45801 22.2 3.43967C22.0605 3.39222 21.9153 3.36363 21.7683 3.35467C21.7333 3.35134 21.7016 3.33301 21.6666 3.33301H9.99996C8.16163 3.33301 6.66663 4.82801 6.66663 6.66634V33.333C6.66663 35.1713 8.16163 36.6663 9.99996 36.6663H30C31.8383 36.6663 33.3333 35.1713 33.3333 33.333V14.9997C33.3333 14.9647 33.315 14.933 33.3116 14.8963C33.3035 14.7492 33.2749 14.6039 33.2266 14.4647C33.21 14.4113 33.195 14.3597 33.1716 14.3097ZM27.6433 13.333H23.3333V9.02301L27.6433 13.333ZM9.99996 33.333V6.66634H20V14.9997C20 15.4417 20.1756 15.8656 20.4881 16.1782C20.8007 16.4907 21.2246 16.6663 21.6666 16.6663H30L30.0033 33.333H9.99996Z"
                                fill="white"
                              />
                              <path
                                d="M13.3334 19.9997H26.6667V23.333H13.3334V19.9997ZM13.3334 26.6663H26.6667V29.9997H13.3334V26.6663ZM13.3334 13.333H16.6667V16.6663H13.3334V13.333Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12 ">
                                <div className="row">
                                  <div className="col-12 col-lg-6 col-md-6 px-0">
                                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold  pt-3">
                                      {t("viewEvidence")}
                                    </p>
                                  </div>
                                  <div className="col-12 col-lg-6 col-md-6 px-0 d-flex justify-content-end">
                                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold  pt-3">
                                      <Image className={"nm-mic"}></Image>
                                      <input
                                        type="file"
                                        multiple
                                        accept="image/*, video/*"
                                        name={`field.file_path`}
                                        className="file-upload__input"
                                        onChange={this._handleImageChange}
                                      />
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12">
                                    <div className="images-section">
                                      {this.state.reportDetail !==
                                        undefined && (
                                        <div className="d-flex gap-2 flex-wrap">
                                          {/* Existing Images */}
                                          {this.state.evidenceImage &&
                                            this.state.evidenceImage.map(
                                              (data, index) => {
                                                if (
                                                  data.evidence_format.includes(
                                                    "image",
                                                  ) ||
                                                  data.evidence_format === null
                                                ) {
                                                  return (
                                                    <ImageCard
                                                      key={index}
                                                      imageUrl={
                                                        data.evidence_image
                                                      }
                                                      onDelete={() =>
                                                        this._removeImageFile(
                                                          index,
                                                          "exist",
                                                        )
                                                      }
                                                      onImageClick={() =>
                                                        this.setState({
                                                          lightboxactive: true,
                                                        })
                                                      }
                                                    />
                                                  );
                                                } else {
                                                  return (
                                                    <VideoCard
                                                      key={index}
                                                      videoUrl={
                                                        data.evidence_image
                                                      }
                                                      onDelete={() =>
                                                        this._removeImageFile(
                                                          index,
                                                          "exist",
                                                        )
                                                      }
                                                    />
                                                  );
                                                }
                                              },
                                            )}

                                          {/* New Uploaded Files */}
                                          {this.state.files &&
                                            this.state.files.map(
                                              (fileData, index) => (
                                                <ImageCard
                                                  key={index}
                                                  imageUrl={URL.createObjectURL(
                                                    fileData.file,
                                                  )}
                                                  onDelete={() =>
                                                    this._removeImageFile(
                                                      index,
                                                      "new",
                                                    )
                                                  }
                                                />
                                              ),
                                            )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="cbp_tmicon cbp_tmicon-phone">
                            <svg
                              width={40}
                              height={40}
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M33.1716 14.3097C33.0926 14.1288 32.982 13.9634 32.845 13.8213L22.845 3.82134C22.7029 3.68431 22.5375 3.57369 22.3566 3.49467C22.3066 3.47134 22.2533 3.45801 22.2 3.43967C22.0605 3.39222 21.9153 3.36363 21.7683 3.35467C21.7333 3.35134 21.7016 3.33301 21.6666 3.33301H9.99996C8.16163 3.33301 6.66663 4.82801 6.66663 6.66634V33.333C6.66663 35.1713 8.16163 36.6663 9.99996 36.6663H30C31.8383 36.6663 33.3333 35.1713 33.3333 33.333V14.9997C33.3333 14.9647 33.315 14.933 33.3116 14.8963C33.3035 14.7492 33.2749 14.6039 33.2266 14.4647C33.21 14.4113 33.195 14.3597 33.1716 14.3097ZM27.6433 13.333H23.3333V9.02301L27.6433 13.333ZM9.99996 33.333V6.66634H20V14.9997C20 15.4417 20.1756 15.8656 20.4881 16.1782C20.8007 16.4907 21.2246 16.6663 21.6666 16.6663H30L30.0033 33.333H9.99996Z"
                                fill="white"
                              />
                              <path
                                d="M13.3334 19.9997H26.6667V23.333H13.3334V19.9997ZM13.3334 26.6663H26.6667V29.9997H13.3334V26.6663ZM13.3334 13.333H16.6667V16.6663H13.3334V13.333Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12 ">
                                <div className="row">
                                  <div className="col-12 px-0">
                                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold  pt-3">
                                      {t("observation")}
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12">
                                    <div className="feild-group rd-box">
                                      <textarea
                                        className="form-control"
                                        onChange={(event) =>
                                          this._handleChange(
                                            event.target.value,
                                            "observation",
                                          )
                                        }
                                        value={this.state.observationText}
                                      ></textarea>
                                    </div>
                                    <div className="feild-group rd-box">
                                      {this.state.observationURL != undefined &&
                                        this.state.observationURL.substr(
                                          this.state.observationURL.length - 3,
                                        ) == ".mp3" && (
                                          <div className="audioPreviewer">
                                            <AudioPlayer
                                              src={this.state.observationURL}
                                              showJumpControls={true}
                                              layout="horizontal-reverse"
                                              customVolumeControls={[]}
                                              customAdditionalControls={[]}
                                              style={{
                                                width: "400px",
                                              }}
                                            />
                                            {/* <audio controls>
                                    <source
                                      src={this.state.observationURL}
                                    ></source>
                                  </audio> */}
                                            <Button
                                              variant="outline-link ml-2"
                                              onClick={() =>
                                                this._removeAudioFile(
                                                  "observation",
                                                )
                                              }
                                            >
                                              X
                                            </Button>
                                          </div>
                                        )}
                                      {this.state.observationAudio && (
                                        <div className="audioPreviewer">
                                          <AudioPlayer
                                            src={this.state.observationURL}
                                            showJumpControls={true}
                                            layout="horizontal-reverse"
                                            customVolumeControls={[]}
                                            customAdditionalControls={[]}
                                            style={{
                                              width: "400px",
                                            }}
                                          />
                                          <Button
                                            variant="outline-link ml-2"
                                            onClick={() =>
                                              this._removeAudioFile(
                                                "observation",
                                              )
                                            }
                                          >
                                            X
                                          </Button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="cbp_tmicon cbp_tmicon-phone">
                            <svg
                              width={40}
                              height={40}
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M33.1716 14.3097C33.0926 14.1288 32.982 13.9634 32.845 13.8213L22.845 3.82134C22.7029 3.68431 22.5375 3.57369 22.3566 3.49467C22.3066 3.47134 22.2533 3.45801 22.2 3.43967C22.0605 3.39222 21.9153 3.36363 21.7683 3.35467C21.7333 3.35134 21.7016 3.33301 21.6666 3.33301H9.99996C8.16163 3.33301 6.66663 4.82801 6.66663 6.66634V33.333C6.66663 35.1713 8.16163 36.6663 9.99996 36.6663H30C31.8383 36.6663 33.3333 35.1713 33.3333 33.333V14.9997C33.3333 14.9647 33.315 14.933 33.3116 14.8963C33.3035 14.7492 33.2749 14.6039 33.2266 14.4647C33.21 14.4113 33.195 14.3597 33.1716 14.3097ZM27.6433 13.333H23.3333V9.02301L27.6433 13.333ZM9.99996 33.333V6.66634H20V14.9997C20 15.4417 20.1756 15.8656 20.4881 16.1782C20.8007 16.4907 21.2246 16.6663 21.6666 16.6663H30L30.0033 33.333H9.99996Z"
                                fill="white"
                              />
                              <path
                                d="M13.3334 19.9997H26.6667V23.333H13.3334V19.9997ZM13.3334 26.6663H26.6667V29.9997H13.3334V26.6663ZM13.3334 13.333H16.6667V16.6663H13.3334V13.333Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12 ">
                                <div className="row">
                                  <div className="col-12 px-0">
                                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold  pt-3">
                                      {this.state.userData?.div_dept == 1 ? (
                                        <>{t("division")}/</>
                                      ) : null}
                                      {t("department")}/{t("contractor")}/
                                      {t("location")}
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  {this.state.userData?.div_dept == 1 && (
                                    <div className="col col-lg-4 col-md-4">
                                      <div className="col-12  px-0">
                                        <div className="clide-v2-title mb-1 ">
                                          <label className="clide-v2-fs-4 mb-0 ">
                                            {t("division")}
                                          </label>
                                        </div>
                                      </div>
                                      <div className="clide-v2-title mb-1 d-flex align-items-baseline">
                                        <select
                                          className="form-control"
                                          value={
                                            this.state.selectedDivisionId || ""
                                          }
                                          onChange={(event) =>
                                            this._divisionChangeHandle(
                                              event.target.value,
                                            )
                                          }
                                        >
                                          <option value="0">
                                            {t("selectDivision")}
                                          </option>
                                          {this.state.divisionList.map(
                                            (item, index) => (
                                              <option
                                                value={item.id}
                                                key={`divisionList-${index}`}
                                              >
                                                {item.name}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                  )}

                                  <div className="col col-lg-4 col-md-4">
                                    <div className="col-12  px-0">
                                      <div className="clide-v2-title mb-1 ">
                                        <label className="clide-v2-fs-4 mb-0 ">
                                          {t("department")}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1 d-flex align-items-baseline">
                                      <select
                                        className="form-control"
                                        value={
                                          this.state.selectedDepartmentId || ""
                                        }
                                        onChange={(event) =>
                                          this._departmentChangeHandle(
                                            event.target.value,
                                          )
                                        }
                                      >
                                        <option value="0">
                                          {t("select")} {t("department")}
                                        </option>
                                        {this.state.departmentList.map(
                                          (item, index) => (
                                            <option
                                              value={item.id}
                                              key={`departmentList-${index}`}
                                            >
                                              {item.name}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                    </div>
                                  </div>

                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "contractor",
                                  ) ? (
                                    <div className="col col-lg-4 col-md-4">
                                      <div className="col-12  px-0">
                                        <div className="clide-v2-title mb-1 ">
                                          <label className="clide-v2-fs-4 mb-0 ">
                                            {t("contractor")}
                                          </label>
                                        </div>
                                      </div>
                                      <div className="clide-v2-title mb-1 d-flex align-items-baseline">
                                        <select
                                          className="form-control"
                                          value={
                                            this.state.selectedContractorId ||
                                            ""
                                          }
                                          onChange={(event) =>
                                            this._contractorChangeHandle(
                                              event.target.value,
                                            )
                                          }
                                        >
                                          <option value="0">
                                            {t("select")} {t("contractor")}
                                          </option>
                                          {this.state.contractorList.map(
                                            (item, index) => (
                                              <option
                                                value={item.id}
                                                key={`contractorList-${index}`}
                                              >
                                                {item.contractor}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                  ) : null}

                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "zone",
                                  ) ? (
                                    <div className="col col-lg-4 col-md-4">
                                      <div className="col-12  px-0">
                                        <div className="clide-v2-title mb-1 ">
                                          <label className="clide-v2-fs-4 mb-0 ">
                                            {t("zone")}
                                          </label>
                                        </div>
                                      </div>
                                      <div>
                                        <div className="clide-v2-title mb-1 d-flex align-items-baseline">
                                          <select
                                            className="form-control"
                                            value={
                                              this.state.selectedZoneId || ""
                                            }
                                            onChange={(event) =>
                                              this._zoneChangeHandle(
                                                event.target.value,
                                              )
                                            }
                                          >
                                            <option value="0">
                                              {t("select")} {t("zone")}
                                            </option>
                                            {this.state.zoneList.map(
                                              (item, index) => (
                                                <option
                                                  value={item.id}
                                                  key={`zoneList-${index}`}
                                                >
                                                  {item.zone}
                                                </option>
                                              ),
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "location",
                                  ) ? (
                                    <div className="col col-lg-4 col-md-4">
                                      <div className="col-12  px-0">
                                        <div className="clide-v2-title mb-1 ">
                                          <label className="clide-v2-fs-4 mb-0 ">
                                            {t("location")}
                                          </label>
                                        </div>
                                      </div>
                                      <div>
                                        <div className="clide-v2-title mb-1 d-flex align-items-baseline">
                                          <select
                                            className="form-control"
                                            value={
                                              this.state.selectedLocationId ||
                                              ""
                                            }
                                            onChange={(event) =>
                                              this._locationChangeHandle(
                                                event.target.value,
                                              )
                                            }
                                          >
                                            <option value="0">
                                              {t("select")} {t("location")}
                                            </option>
                                            {this.state.locationList.map(
                                              (item, index) => (
                                                <option
                                                  value={item.id}
                                                  key={`locationList-${index}`}
                                                >
                                                  {item.location}
                                                </option>
                                              ),
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="cbp_tmicon cbp_tmicon-phone">
                            <svg
                              width={40}
                              height={40}
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M33.1716 14.3097C33.0926 14.1288 32.982 13.9634 32.845 13.8213L22.845 3.82134C22.7029 3.68431 22.5375 3.57369 22.3566 3.49467C22.3066 3.47134 22.2533 3.45801 22.2 3.43967C22.0605 3.39222 21.9153 3.36363 21.7683 3.35467C21.7333 3.35134 21.7016 3.33301 21.6666 3.33301H9.99996C8.16163 3.33301 6.66663 4.82801 6.66663 6.66634V33.333C6.66663 35.1713 8.16163 36.6663 9.99996 36.6663H30C31.8383 36.6663 33.3333 35.1713 33.3333 33.333V14.9997C33.3333 14.9647 33.315 14.933 33.3116 14.8963C33.3035 14.7492 33.2749 14.6039 33.2266 14.4647C33.21 14.4113 33.195 14.3597 33.1716 14.3097ZM27.6433 13.333H23.3333V9.02301L27.6433 13.333ZM9.99996 33.333V6.66634H20V14.9997C20 15.4417 20.1756 15.8656 20.4881 16.1782C20.8007 16.4907 21.2246 16.6663 21.6666 16.6663H30L30.0033 33.333H9.99996Z"
                                fill="white"
                              />
                              <path
                                d="M13.3334 19.9997H26.6667V23.333H13.3334V19.9997ZM13.3334 26.6663H26.6667V29.9997H13.3334V26.6663ZM13.3334 13.333H16.6667V16.6663H13.3334V13.333Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12 ">
                                <div className="row">
                                  <div className="col-12 px-0">
                                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold  pt-3">
                                      {t("actionByDueDate")}
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col mb-2 px-0">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("reportedBy")}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        <div className="output-text">
                                          {reportData.reported_by == "" ||
                                          reportData.reported_by ==
                                            undefined ? (
                                            <p className="na-text">NA</p>
                                          ) : (
                                            <div className="output-text">
                                              {reportData.reported_by}
                                            </div>
                                          )}
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col mb-2 px-0">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("reportedOn")}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        <div className="output-text">
                                          {reportData.reported_date == "" ||
                                          reportData.reported_date ==
                                            undefined ? (
                                            <p className="na-text">NA</p>
                                          ) : (
                                            <div className="output-text">
                                              {/* {reportData.reported_date} */}
                                              {`${convertDateFromTimezone(reportData.reported_date)}`}
                                            </div>
                                          )}
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                  {reportData.assign_to ? (
                                    <div className="col mb-2 px-0">
                                      <div className="col-12 col-md-12 col-lg-12 px-0">
                                        <div className="clide-v2-title mb-1">
                                          <label className="clide-v2-fs-4 mb-0">
                                            {t("assignedTo")}
                                          </label>
                                        </div>
                                      </div>
                                      <div className="clide-v2-title mb-1">
                                        <label className="">
                                          <div className="output-text">
                                            {reportData.assign_to == "" ||
                                            reportData.assign_to ==
                                              undefined ? (
                                              <p className="na-text">NA</p>
                                            ) : (
                                              <div className="output-text">
                                                {reportData.assign_to}
                                              </div>
                                            )}
                                          </div>
                                        </label>
                                      </div>
                                    </div>
                                  ) : null}

                                  {CheckFormSettingField(
                                    this.state.formSetting?.setting,
                                    "target date",
                                  ) ? (
                                    <div className="col mb-2 px-0">
                                      <div className="col-12 col-md-12 col-lg-12 px-0">
                                        <div className="clide-v2-title mb-1">
                                          <label className="clide-v2-fs-4 mb-0">
                                            {t("targetDate")}
                                          </label>
                                        </div>
                                      </div>
                                      <div class="d-flex flex-direction-m">
                                        <div class="input-group mb-3  w-100">
                                          <DatePicker
                                            selected={
                                              this.state.selectedTargetDate
                                            }
                                            dateFormat="dd/MM/yyyy"
                                            maxDate={this.state.selectedOldDate}
                                            className="form-control "
                                            wrapperClassName="flex-grow-1"
                                            onChange={(jsDate) =>
                                              this._handleChange(
                                                jsDate,
                                                "target_date",
                                              )
                                            }
                                          />
                                          <button
                                            class="btn btn-secondary clide-v2-bg-white clide-v2-border-color border-start-0"
                                            type="button"
                                            id="button-addon2"
                                          >
                                            <svg
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M12.6668 2.66634H11.3335V1.99967C11.3335 1.82286 11.2633 1.65329 11.1382 1.52827C11.0132 1.40325 10.8436 1.33301 10.6668 1.33301C10.49 1.33301 10.3204 1.40325 10.1954 1.52827C10.0704 1.65329 10.0002 1.82286 10.0002 1.99967V2.66634H6.00016V1.99967C6.00016 1.82286 5.92992 1.65329 5.8049 1.52827C5.67988 1.40325 5.51031 1.33301 5.3335 1.33301C5.15668 1.33301 4.98712 1.40325 4.86209 1.52827C4.73707 1.65329 4.66683 1.82286 4.66683 1.99967V2.66634H3.3335C2.80306 2.66634 2.29436 2.87705 1.91928 3.25213C1.54421 3.6272 1.3335 4.13591 1.3335 4.66634V12.6663C1.3335 13.1968 1.54421 13.7055 1.91928 14.0806C2.29436 14.4556 2.80306 14.6663 3.3335 14.6663H12.6668C13.1973 14.6663 13.706 14.4556 14.081 14.0806C14.4561 13.7055 14.6668 13.1968 14.6668 12.6663V4.66634C14.6668 4.13591 14.4561 3.6272 14.081 3.25213C13.706 2.87705 13.1973 2.66634 12.6668 2.66634ZM13.3335 12.6663C13.3335 12.8432 13.2633 13.0127 13.1382 13.1377C13.0132 13.2628 12.8436 13.333 12.6668 13.333H3.3335C3.15668 13.333 2.98712 13.2628 2.86209 13.1377C2.73707 13.0127 2.66683 12.8432 2.66683 12.6663V7.99967H13.3335V12.6663ZM13.3335 6.66634H2.66683V4.66634C2.66683 4.48953 2.73707 4.31996 2.86209 4.19494C2.98712 4.06991 3.15668 3.99967 3.3335 3.99967H4.66683V4.66634C4.66683 4.84315 4.73707 5.01272 4.86209 5.13775C4.98712 5.26277 5.15668 5.33301 5.3335 5.33301C5.51031 5.33301 5.67988 5.26277 5.8049 5.13775C5.92992 5.01272 6.00016 4.84315 6.00016 4.66634V3.99967H10.0002V4.66634C10.0002 4.84315 10.0704 5.01272 10.1954 5.13775C10.3204 5.26277 10.49 5.33301 10.6668 5.33301C10.8436 5.33301 11.0132 5.26277 11.1382 5.13775C11.2633 5.01272 11.3335 4.84315 11.3335 4.66634V3.99967H12.6668C12.8436 3.99967 13.0132 4.06991 13.1382 4.19494C13.2633 4.31996 13.3335 4.48953 13.3335 4.66634V6.66634Z"
                                                fill="#FF6347"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-3 col-md-3">
                <div className="row row-gap-4">
                  <div className="col-12">
                    <div className="clide-v2-card-box-1">
                      <div className="p-3 ">
                        <div className="d-flex-center">
                          <Button
                            variant=""
                            className="border clide-v2-primary-color font-weight-bolder"
                          >
                            {t("usersLiked")}
                          </Button>
                        </div>
                        <div className="rd-left-bottom side-invite-user">
                          <div className="totalLikedUser">
                            <span className="clide-v2-fs-4 clide-v2-primary-color fw-bold  pt-3">
                              {t("all")}
                            </span>
                            <span className="count">
                              {this.state.likeNumber}
                            </span>
                          </div>

                          {this.state.userLike != "" ? (
                            this.state.userLike?.map((items, index) => (
                              <div className="user-list" key={index}>
                                <img
                                  src={items.user_profile}
                                  alt={items.user_name}
                                  className="clide-v2-profile-img"
                                />
                                <h6 className="user-name">{items.user_name}</h6>
                              </div>
                            ))
                          ) : (
                            <p className="my-3 text-center border p-3 clide-v2-primary rounded-4 clide-v2-white-color">
                              {t("likesNotAvailable")}{" "}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="clide-v2-card-box-1 p-3 mt-2">
                      <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3">
                        {t("investigationTeam")}
                      </p>
                      <hr />

                      <div className="d-flex flex-wrap gap-2">
                        {reportData.nm_reported_detail_people_involved_list
                          ?.length
                          ? reportData.nm_reported_detail_people_involved_list.map(
                              (item, index) => (
                                <div>
                                  <div
                                    className=" align-items-center border d-flex justify-content-between pr-3 rounded-5 "
                                    key={`investigation-team-${index}`}
                                  >
                                    <button
                                      type="button"
                                      className="icon-button"
                                      title={item.user_name}
                                    >
                                      <span className="">
                                        {getInitials(item.user_name)}
                                      </span>
                                    </button>
                                    &nbsp;{" "}
                                    <label className="font-weight-bold mb-0 mx-2">
                                      {item.user_name ?? "NA"}{" "}
                                    </label>
                                  </div>
                                </div>
                              ),
                            )
                          : null}
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="clide-v2-card-box-1 p-3 mt-2">
                      <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3">
                        {reportData.activity} | {t("analysis")}
                      </p>
                      <hr />
                      {reportData.activity_analysis?.fa_number == 0 &&
                      reportData.activity_analysis?.mtc_number == 0 &&
                      reportData.activity_analysis?.rta_number == 0 &&
                      reportData.activity_analysis?.lti_number == 0 ? (
                        <div className="graph-not-available-text">
                          {t("graphNotAvailable")}
                        </div>
                      ) : (
                        <div className="col-12  mb-3">
                          <div className="clide-v2-white-box">
                            <div className="row align-items-center">
                              <div className="col-12  my-2">
                                <div className="sm-graph-modal-legend-text text-center my-2">
                                  <b>
                                    {t("ira")} {t("analysis")}
                                  </b>
                                </div>

                                <div>
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={analysisChart}
                                  />
                                </div>
                              </div>
                              <div className="col-12  ">
                                <div className="outer-legend-block">
                                  <Scrollbars
                                    style={{
                                      height: `6rem`,
                                      margin: "0.5rem 0.2rem 0.5rem 0",
                                    }}
                                    renderView={(props) => (
                                      <div
                                        style={{
                                          paddingRight: "15px",
                                          ...props.style,
                                          overflowX: "hidden",
                                        }}
                                      />
                                    )}
                                  >
                                    <div className="clide-v2-graph-left-box  d-flex align-items-center  ">
                                      <span
                                        className="soi-kanban-modal-legend-box clide-v2-square-span "
                                        style={{ backgroundColor: "#FF4242" }}
                                      ></span>
                                      <span className="sm-graph-modal-legend-text ">
                                        FA
                                      </span>
                                      <span className=" ml-auto">
                                        {
                                          reportData?.activity_analysis
                                            ?.fa_number
                                        }
                                      </span>
                                    </div>
                                    <div className="soi-kanban-inner-legend-block  ">
                                      <span
                                        className="soi-kanban-modal-legend-box clide-v2-square-span"
                                        style={{ backgroundColor: "#086992" }}
                                      ></span>
                                      <span className="sm-graph-modal-legend-text my-2">
                                        MTC
                                      </span>
                                      <span className="legend-number float-end">
                                        {
                                          reportData?.activity_analysis
                                            ?.mtc_number
                                        }
                                      </span>
                                    </div>
                                    <div className="soi-kanban-inner-legend-block  ">
                                      <span
                                        className="soi-kanban-modal-legend-box clide-v2-square-span"
                                        style={{ backgroundColor: "#FAAC15" }}
                                      ></span>
                                      <span className="sm-graph-modal-legend-text my-2">
                                        RTA
                                      </span>
                                      <span className="legend-number float-end">
                                        {
                                          reportData?.activity_analysis
                                            ?.rta_number
                                        }
                                      </span>
                                    </div>
                                    {/* /* // Britannia v01
  //  Making this change to ...(Integrate this rta to tra and faid oi notable integration because of britian custoimization ) */}

                                    <div className="soi-kanban-inner-legend-block  ">
                                      <span
                                        className="soi-kanban-modal-legend-box clide-v2-square-span"
                                        style={{ backgroundColor: "#18DA07" }}
                                      ></span>
                                      <span className="sm-graph-modal-legend-text my-2">
                                        LTI
                                      </span>
                                      <span className="legend-number float-end">
                                        {
                                          reportData?.activity_analysis
                                            ?.lti_number
                                        }
                                      </span>
                                    </div>
                                  </Scrollbars>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {reportData.activity_analysis?.nm_ua_number == 0 &&
                      reportData.activity_analysis?.nm_uc_number == 0 ? (
                        <div className="graph-not-available-text">
                          {t("graphNotAvailable")}
                        </div>
                      ) : (
                        <div className="col-12  mb-3">
                          <div className="clide-v2-white-box">
                            <div className="row align-items-center">
                              <div className="col-12  my-2">
                                <div className="sm-graph-modal-legend-text text-center my-2">
                                  <b>
                                    {t("nm")} {t("analysis")}
                                  </b>
                                </div>

                                <div>
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={nmuaUcChart}
                                  />
                                </div>
                              </div>
                              <div className="col-12  ">
                                <div className="outer-legend-block">
                                  <Scrollbars
                                    style={{
                                      height: `6rem`,
                                      margin: "0.5rem 0.2rem 0.5rem 0",
                                    }}
                                    renderView={(props) => (
                                      <div
                                        style={{
                                          paddingRight: "15px",
                                          ...props.style,
                                          overflowX: "hidden",
                                        }}
                                      />
                                    )}
                                  >
                                    <div className="clide-v2-graph-left-box  d-flex align-items-center  ">
                                      <span
                                        className="soi-kanban-modal-legend-box clide-v2-square-span "
                                        style={{
                                          backgroundColor:
                                            reportData.activity_analysis
                                              ?.nm_ua_color,
                                        }}
                                      ></span>
                                      <span className="sm-graph-modal-legend-text ">
                                        {t("unsafeAct")}
                                      </span>
                                      <span className=" ml-auto">
                                        {
                                          reportData.activity_analysis
                                            ?.nm_ua_number
                                        }
                                      </span>
                                    </div>
                                    <div className="soi-kanban-inner-legend-block  ">
                                      <span
                                        className="soi-kanban-modal-legend-box clide-v2-square-span"
                                        style={{
                                          backgroundColor:
                                            reportData.activity_analysis
                                              ?.nm_uc_color,
                                        }}
                                      ></span>
                                      <span className="sm-graph-modal-legend-text my-2">
                                        {t("unsafeCondition")}
                                      </span>
                                      <span className="legend-number float-end">
                                        {
                                          reportData.activity_analysis
                                            ?.nm_uc_number
                                        }
                                      </span>
                                    </div>
                                  </Scrollbars>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {reportData.activity_analysis?.ua_number == 0 &&
                      reportData.activity_analysis?.uc_number == 0 ? (
                        <div className="graph-not-available-text">
                          {t("graphNotAvailable")}
                        </div>
                      ) : (
                        <div className="col-12  mb-3">
                          <div className="clide-v2-white-box">
                            <div className="row align-items-center">
                              <div className="col-12  my-2">
                                <div className="sm-graph-modal-legend-text text-center my-2">
                                  <b>{t("uaucAnalysis")}</b>
                                </div>

                                <div>
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={uaUcChart}
                                  />
                                </div>
                              </div>
                              <div className="col-12  ">
                                <div className="outer-legend-block">
                                  <Scrollbars
                                    style={{
                                      height: `6rem`,
                                      margin: "0.5rem 0.2rem 0.5rem 0",
                                    }}
                                    renderView={(props) => (
                                      <div
                                        style={{
                                          paddingRight: "15px",
                                          ...props.style,
                                          overflowX: "hidden",
                                        }}
                                      />
                                    )}
                                  >
                                    <div className="clide-v2-graph-left-box  d-flex align-items-center  ">
                                      <span
                                        className="soi-kanban-modal-legend-box clide-v2-square-span "
                                        style={{ backgroundColor: "#C7AC83" }}
                                      ></span>
                                      <span className="sm-graph-modal-legend-text ">
                                        {t("unsafeAct")}
                                      </span>
                                      <span className=" ml-auto">
                                        {
                                          reportData.activity_analysis
                                            ?.ua_number
                                        }
                                      </span>
                                    </div>
                                    <div className="soi-kanban-inner-legend-block  ">
                                      <span
                                        className="soi-kanban-modal-legend-box clide-v2-square-span"
                                        style={{ backgroundColor: "#554040" }}
                                      ></span>
                                      <span className="sm-graph-modal-legend-text my-2">
                                        {t("unsafeCondition")}
                                      </span>
                                      <span className="legend-number float-end">
                                        {
                                          reportData.activity_analysis
                                            ?.uc_number
                                        }
                                      </span>
                                    </div>
                                  </Scrollbars>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default compose(
  withRouter,
  withTranslation(["nm", "util"]),
)(NmEditReportingDetail);

const CardWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  overflow: hidden;
  width: 200px;
  height: 200px;
  background-color: white; /* White background */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */
`;

const CloseIcon = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.6); /* Dark background for visibility */
  border: none;
  color: white;
  font-size: 18px;
  padding: 2px 11px;
  border-radius: 50%;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

const ImageDisplay = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ImageCard = ({ imageUrl, onDelete, onImageClick }) => {
  return (
    <CardWrapper>
      <ImageDisplay src={imageUrl} alt="Preview" onClick={onImageClick} />
      <CloseIcon onClick={onDelete}>×</CloseIcon>
    </CardWrapper>
  );
};

ImageCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onImageClick: PropTypes.func,
};

const VideoWrapper = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const VideoCard = ({ videoUrl, onDelete }) => {
  return (
    <CardWrapper>
      <VideoWrapper controls>
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </VideoWrapper>
      <CloseIcon onClick={onDelete}>×</CloseIcon>
    </CardWrapper>
  );
};

VideoCard.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};
